import React from "react";
// import image1 from "./images/austin-distel-FQ0tfv5xzBA-unsplash.jpg";
// import image3 from "./images/helena-lopes-1m2LQEonm2A-unsplash.jpg";
// import image2 from "./images/daria-nepriakhina-_XR5rkprHQU-unsplash.jpg";
// import image4 from "./images/tim-dennert-yKhAns1tW54-unsplash.jpg";
// import image5 from "./images/ben-eaton-na4mEdwR7uA-unsplash.jpg";

// import phone from "./images/phone.png";

import "./index.scss";

// const sections = [
//   {
//     title: "Is your alarm on or off?",
//     description: [
//       {
//         image: phone,
//         caption:
//           "Take control of your existing or new alarm system with our remote arm/disarm feature.",
//       },
//     ],
//     image: image1,
//   },
//   {
//     title: "Did someone break in?",
//     description: [
//       {
//         image: phone,
//         caption:
//           "Receive all burglary and alarm messages on your mobile phone within seconds.",
//       },
//     ],
//     image: image2,
//   },
//   {
//     title: "Have an emergency?",
//     description: [
//       {
//         image: phone,
//         caption:
//           "Send panic alarm with real time GPS location to your Pocket Secure contacts.",
//       },
//     ],
//     image: image4,
//   },
//   {
//     title: "Have multiple locations?",
//     description: [
//       {
//         image: phone,
//         caption: "Take control of multiple sites such as home and business.",
//       },
//     ],
//     image: image5,
//   },
//   {
//     title: "Sharing your property?",
//     description: [
//       {
//         image: phone,
//         caption:
//           "Manage who can arm / disarm your alarm, who can open doors. Manage which of your users can receive alarm, system and On/Off notifications. Check when your alarm system was armed or disarmed.",
//       },
//     ],
//     image: image3,
//   },
// ];

export default function Page() {
  return (
    // <div className="LandingPage__root">
    //   {sections.map((section) => {
    //     return (
    //       <div
    //         key={section.title}
    //         className="SegmentWrapper"
    //         style={{
    //           backgroundImage: `url(${section.image})`,
    //         }}
    //       >
    //         <div className="Segment">
    //           <div className="SegmentHead">
    //             <div className="SegmentTitle">{section.title}</div>
    //           </div>
    //           <div className="SegmentBody">
    //             {section.description.map((description) => (
    //               <div className="SegmentBodyItem">
    //                 <div className="image">
    //                   <img alt="" src={description.image} />
    //                 </div>
    //                 <div className="caption">{description.caption}</div>
    //               </div>
    //             ))}
    //           </div>
    //         </div>
    //       </div>
    //     );
    //   })}
    // </div>
    <p>
      This page has been moved to{" "}
      <a href="https://pocket-secure.com/">https://pocket-secure.com/</a>.
      Please update your bookmark.
    </p>
  );
}
